export type StripePayment = {
  id: string;
};

export const getStripePaymentData = (data: { id: string }): StripePayment => ({
  id: data.id,
});
